export default "__VITE_ASSET__DKR2HWr2__"